export enum Provider {
    Bedrock = "bedrock",
    Vertex = "vertex",
    Anthropic = "anthropic",
    Unknown = "unknown",
}

export type LLMProviderKind = Provider.Bedrock | Provider.Vertex | Provider.Anthropic;

export const parseProviderFromEndpoint = (endpoint: string): Provider => {
    if (endpoint.startsWith("bedrock://") || endpoint.includes("bedrock") || endpoint.includes("amazonaws")) {
        return Provider.Bedrock;
    }
    if (endpoint.startsWith("vertex://")) {
        return Provider.Vertex;
    }
    if (endpoint.includes("anthropic")) {
        return Provider.Anthropic;
    }
    return Provider.Unknown;
};
